import Button from "components/components/Button/Button";
import styled from "styled-components";
import colours from "styles/colours";
import { resetButtonStyling } from "styles/commonStyles";
import fonts from "styles/fonts";

export const Container = styled.span`
  margin-left: 0.6em;
`;

export const StyledButton = styled(Button)`
  ${resetButtonStyling};
  text-transform: none;
  letter-spacing: normal;
  font-size: ${fonts.small};
  text-decoration: underline;
  align-items: start;
  :hover {
    color: ${colours.elexonBlue};
  }

  &:active {
    box-shadow: none;
  }
`;
